<template>
    <v-dialog ref="dialog"
              v-model="showModal"
              :return-value.sync="dateTime"
              persistent
              max-width="320px"
              :disabled="disabled">
        <template v-slot:activator="{ on }">
          <v-text-field :disabled="disabled"
                        color="kbDarkBlueText"
                        @click:clear="reset()"
                        v-on="on"
                        v-model="dateTime"
                        :label="label"
                        :rules="rules"
                        clearable
                        prepend-icon="event"
                        readonly>
          </v-text-field>
        </template>
        <template v-if="showDatePicker">
            <v-date-picker v-model="date"
                           color="kbBlue"
                           scrollable
                           width="100%"
                           :min="min">
                <v-spacer></v-spacer>
                <v-btn outlined color="error" @click="showModal = false">Cancelar</v-btn>
                <v-btn color="kbBlue" dark :disabled="!date" @click="showTimePicker()">Aceptar</v-btn>
            </v-date-picker>
        </template>
        <template v-else>
            <v-time-picker color="kbBlue"
                           v-model="time">
                <v-spacer/>
                <v-btn color="error" outlined @click="showModal = false">Cancelar</v-btn>
                <v-btn color="kbBlue" dark :disabled="!time" @click="save()">Aceptar</v-btn>
            </v-time-picker>
        </template>
    </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
  created () {
    if (this.value) {
      this.date = moment(this.value).format('YYYY-MM-DD')
      this.time = moment(this.value).format('hh:mm')
    }
  },
  computed: {
    dateTime: {
      get () {
        if (!this.date && !this.time) return ''
        return this.date + ' ' + this.time
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      showDatePicker: true,
      showModal: false,
      date: '',
      time: ''
    }
  },
  methods: {
    reset () {
      this.date = ''
      this.time = ''
      this.$refs.dialog.save('')
      this.$emit('input', '')
      this.$emit('click:clear')
    },
    save () {
      this.$refs.dialog.save(this.date + ' ' + this.time)
    },
    showTimePicker () {
      this.showDatePicker = false
    }
  },
  props: {
    disabled: {
      type: Boolean
    },
    label: {
      default: '',
      type: String
    },
    min: {
      default: '',
      type: String
    },
    rules: {
      default: () => ([]),
      type: Array
    },
    value: {
      type: String
    }
  },
  watch: {
    showModal () {
      this.showDatePicker = true
    },
    value (value) {
      if (value === '') {
        this.reset()
      }
    }
  }
}
</script>
